<template>
    <div class="row">
    <ul class="list-inline text-left" style="margin-bottom:0px">
    <!-- <li ><Button class="btn btn-default  mb5" @click="btnClicked('中西區')">中西區</Button></li> -->
      <li ><a class="btn btn-default  mb5"  :href="level+'?district=中西區'" title="中西區">中西區</a></li>
    <li ><a class="btn btn-default  mb5"  :href="level+'?district=灣仔區'" title="灣仔區">灣仔區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=香港東區'" title="香港東區">香港東區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=香港南區'" title="香港南區">香港南區</a></li>
</ul>
<ul class="list-inline text-left" style="margin-bottom:0px">    
    <li ><a class="btn btn-default  mb5" :href="level+'?district=油尖旺區'" title="油尖旺區">油尖旺區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=深水埗區'" title="深水埗區">深水埗區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=九龍城區'" title="九龍城區">九龍城區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=黃大仙區'" title="黃大仙區">黃大仙區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=觀塘區'" title="觀塘區">觀塘區</a></li>
</ul>
<ul class="list-inline text-left" style="margin-bottom:5px">        
    <li ><a class="btn btn-default  mb5" :href="level+'?district=葵青區'" title="葵青區">葵青區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=荃灣區'" title="荃灣區">荃灣區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=屯門區'" title="屯門區">屯門區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=元朗區'" title="元朗區">元朗區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=北區'" title="北區">北區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=大埔區'" title="大埔區">大埔區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=沙田區'" title="沙田區">沙田區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=西貢區'" title="西貢區">西貢區</a></li>
    <li ><a class="btn btn-default  mb5" :href="level+'?district=離島區'" title="離島區">離島區</a></li>
</ul>
</div>
</template>
<script>
export default {
  props: {
    model: null,
    level:"",
    districts: "",
  },
  data: function() {
    return {            
    };
  },  
  methods: {       
    btnClicked(d){
        this.model.districts[d] = !(this.model.districts[d]);
    }
  }
};
</script>
<style scoped>
.inline-label{
 position: relative;
    left: -210px;
}
</style>



// WEBPACK FOOTER //
// resources/js/school/DistrictButtons.vue